import { Injectable } from '@angular/core';
import { select, setProps } from '@ngneat/elf';
import { testerStore, Tester } from './tester.store';
import { PersistedModalName } from '@app/shared/models/modal.model';

@Injectable({ providedIn: 'root' })
export class TesterRepository {
  readonly tester$ = testerStore.pipe(select((state) => state));
  readonly showTestMachines$ = testerStore.pipe(select((state) => state.showTestMachines));

  updateTester(props: Partial<Tester>): void {
    testerStore.update(setProps(props));
  }

  reset(): void {
    testerStore.reset();
  }

  getTesterStore(): Tester {
    return testerStore.getValue();
  }

  setShowTestMachines(value: boolean): void {
    this.updateTester({ showTestMachines: value });
  }

  getShowTestMachines(): boolean | null {
    return this.getTesterStore().showTestMachines;
  }

  setBlockedModals(modals: PersistedModalName[]): void {
    this.updateTester({ blockedModals: modals });
  }

  getBlockedModals(): PersistedModalName[] {
    return this.getTesterStore().blockedModals;
  }
}
